import { render, staticRenderFns } from "./process-flow.vue?vue&type=template&id=63bae56a&scoped=true&"
import script from "./process-flow.vue?vue&type=script&lang=js&"
export * from "./process-flow.vue?vue&type=script&lang=js&"
import style0 from "./process-flow.vue?vue&type=style&index=0&id=63bae56a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bae56a",
  null
  
)

export default component.exports